export default __webpack_public_path__ + "static/media/nestle.eb3256b1.png";